import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaWhatsapp, FaTimes, FaQrcode, FaCommentDots } from 'react-icons/fa';
import whatsappQr from '../../assets/images/whatsapp.jpeg';

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showQrModal, setShowQrModal] = useState(false);

  const handleWhatsApp = () => {
    window.open(
      'https://wa.me/254712345678?text=Hello%20PowerCore%20Fitness!%20I%20have%20a%20question.',
      '_blank'
    );
    setIsOpen(false);
  };

  const handleScanQR = () => {
    setShowQrModal(true);
    setIsOpen(false);
  };

  return (
    <>
      {/* Floating Action Button */}
      <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 9999 }}>
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, y: 20, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.9 }}
              transition={{ type: 'spring', damping: 20, stiffness: 300 }}
              style={{ position: 'absolute', bottom: '100%', right: 0, marginBottom: 16 }}
            >
              <div className="flex flex-col gap-3">
                <motion.button
                  whileHover={{ scale: 1.05, x: -5 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleWhatsApp}
                  className="group flex items-center gap-3 bg-white dark:bg-gray-800 hover:bg-green-50 dark:hover:bg-green-900/30 text-gray-700 dark:text-gray-200 px-5 py-3 rounded-2xl shadow-xl transition-all duration-300"
                >
                  <div className="bg-green-500 p-2 rounded-full group-hover:scale-110 transition-transform duration-300">
                    <FaCommentDots className="h-4 w-4 text-white" />
                  </div>
                  <span className="font-medium text-sm whitespace-nowrap">Chat Now</span>
                </motion.button>

                <motion.button
                  whileHover={{ scale: 1.05, x: -5 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleScanQR}
                  className="group flex items-center gap-3 bg-white dark:bg-gray-800 hover:bg-purple-50 dark:hover:bg-purple-900/30 text-gray-700 dark:text-gray-200 px-5 py-3 rounded-2xl shadow-xl transition-all duration-300"
                >
                  <div className="bg-purple-500 p-2 rounded-full group-hover:scale-110 transition-transform duration-300">
                    <FaQrcode className="h-4 w-4 text-white" />
                  </div>
                  <span className="font-medium text-sm whitespace-nowrap">Scan QR Code</span>
                </motion.button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={() => setIsOpen(!isOpen)}
          className="relative bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white p-4 rounded-full shadow-2xl flex items-center justify-center"
          style={{ boxShadow: '0 10px 30px -8px rgba(37,211,102,0.5)' }}
          title="Chat with us"
        >
          <AnimatePresence mode="wait">
            {isOpen ? (
              <motion.div
                key="close"
                initial={{ rotate: -90, opacity: 0 }}
                animate={{ rotate: 0, opacity: 1 }}
                exit={{ rotate: 90, opacity: 0 }}
                transition={{ duration: 0.2 }}
              >
                <FaTimes className="h-6 w-6" />
              </motion.div>
            ) : (
              <motion.div
                key="whatsapp"
                initial={{ rotate: 90, opacity: 0 }}
                animate={{ rotate: 0, opacity: 1 }}
                exit={{ rotate: -90, opacity: 0 }}
                transition={{ duration: 0.2 }}
              >
                <FaWhatsapp className="h-6 w-6" />
              </motion.div>
            )}
          </AnimatePresence>
        </motion.button>
      </div>

      {/* QR Modal rendered in a Portal-like fixed overlay */}
      <AnimatePresence>
        {showQrModal && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 99999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setShowQrModal(false)}
              style={{
                position: 'absolute',
                inset: 0,
                background: 'rgba(0,0,0,0.65)',
                backdropFilter: 'blur(6px)',
                WebkitBackdropFilter: 'blur(6px)',
              }}
            />

            {/* Modal Card */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 24 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 24 }}
              transition={{ type: 'spring', damping: 26, stiffness: 320 }}
              style={{
                position: 'relative',
                zIndex: 1,
                width: '90%',
                maxWidth: '380px',
                maxHeight: '90vh',
                overflowY: 'auto',
                borderRadius: '24px',
                background: 'white',
                boxShadow: '0 32px 80px rgba(0,0,0,0.25)',
              }}
              className="dark:bg-gray-900"
            >
              {/* Header */}
              <div
                style={{
                  background: 'linear-gradient(135deg, #22c55e, #16a34a)',
                  borderRadius: '24px 24px 0 0',
                  padding: '18px 20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <FaWhatsapp style={{ color: 'white', fontSize: '20px' }} />
                  <span style={{ color: 'white', fontWeight: 700, fontSize: '18px' }}>
                    Scan QR Code
                  </span>
                </div>
                <button
                  onClick={() => setShowQrModal(false)}
                  style={{
                    background: 'rgba(255,255,255,0.2)',
                    border: 'none',
                    borderRadius: '50%',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    color: 'white',
                    transition: 'background 0.2s',
                  }}
                  onMouseEnter={e => (e.currentTarget.style.background = 'rgba(255,255,255,0.35)')}
                  onMouseLeave={e => (e.currentTarget.style.background = 'rgba(255,255,255,0.2)')}
                >
                  <FaTimes style={{ fontSize: '13px' }} />
                </button>
              </div>

              {/* Body */}
              <div style={{ padding: '24px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>

                {/* QR Image — constrained so it never overflows */}
                <div
                  style={{
                    background: 'white',
                    borderRadius: '16px',
                    padding: '12px',
                    border: '1.5px solid #e5e7eb',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={whatsappQr}
                    alt="WhatsApp QR Code"
                    style={{
                      width: '200px',
                      height: '200px',
                      objectFit: 'contain',
                      display: 'block',
                    }}
                  />
                </div>

                {/* Instruction steps */}
                <div style={{ width: '100%', textAlign: 'center' }}>
                  <p style={{ fontSize: '13px', fontWeight: 600, color: '#374151', marginBottom: '12px' }}
                     className="dark:text-gray-200">
                    How to scan
                  </p>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    {[
                      { n: '1', label: 'Open WhatsApp' },
                      { n: '2', label: 'Tap Menu (⋮)' },
                      { n: '3', label: 'WhatsApp Web' },
                    ].map((step, i, arr) => (
                      <React.Fragment key={step.n}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                          <span
                            style={{
                              width: '24px',
                              height: '24px',
                              borderRadius: '50%',
                              background: '#dcfce7',
                              color: '#16a34a',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '11px',
                              fontWeight: 700,
                            }}
                          >
                            {step.n}
                          </span>
                          <span style={{ fontSize: '11px', color: '#6b7280', whiteSpace: 'nowrap' }}>
                            {step.label}
                          </span>
                        </div>
                        {i < arr.length - 1 && (
                          <span style={{ color: '#d1d5db', fontSize: '16px', marginBottom: '18px' }}>›</span>
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                </div>

                {/* Divider */}
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ flex: 1, height: '1px', background: '#e5e7eb' }} />
                  <span style={{ fontSize: '12px', color: '#9ca3af' }}>or</span>
                  <div style={{ flex: 1, height: '1px', background: '#e5e7eb' }} />
                </div>

                {/* CTA Button */}
                <button
                  onClick={handleWhatsApp}
                  style={{
                    width: '100%',
                    background: 'linear-gradient(135deg, #22c55e, #16a34a)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '14px',
                    padding: '14px',
                    fontSize: '15px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    boxShadow: '0 4px 15px rgba(34,197,94,0.35)',
                    transition: 'opacity 0.2s, transform 0.2s',
                  }}
                  onMouseEnter={e => (e.currentTarget.style.opacity = '0.9')}
                  onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
                  onMouseDown={e => (e.currentTarget.style.transform = 'scale(0.98)')}
                  onMouseUp={e => (e.currentTarget.style.transform = 'scale(1)')}
                >
                  <FaWhatsapp style={{ fontSize: '18px' }} />
                  Start chatting now
                </button>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ChatWidget;